// import React, { useState } from "react";
// import {
//   Box,
//   Grid,
//   TextField,
//   Button,
//   Typography,
//   Checkbox,
//   FormControlLabel,
//   InputAdornment,
// } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";

// // Íconos
// import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
// import { FaXTwitter } from "react-icons/fa6";
// import { FaBluesky } from "react-icons/fa6";

// // Modelos
// import { User } from "../../../core/models/db";
// import { Configuration } from "../../../core/models/db/configuration";

// // Componentes
// import { NumericFormatCustom, RoundedSquareIcon } from "../../components";
// import DragDrop from "../../components/drag-drop/DragDrop";
// import PasswordForm from "../user/components/form/PasswordForm";
// import { useIdentityStore } from "../../../core/store";



// // Variable global para el máximo de caracteres en los campos de descripción
// const MAX_DESCRIPTION_LENGTH = 512;

// interface Props {
//   user: User;
//   config: Configuration;
//   isEditing: boolean;
//   loading?: boolean;
//   onEdit: () => void;
//   onCancel: () => void;
//   checkPassword?: (id: any, password: any) => Promise<any>;
//   onSubmit: (
//     userData: User,
//     configData: Configuration,
//     imageData: {
//       oldImage: string;
//       image: string;
//       file?: File;
//     }
//   ) => void;
// }

// /**
//  * Form para editar User + Configuration,
//  * validando que si el usuario marca una red social, se llenen obligatoriamente
//  * los campos correspondientes.
//  */
// const ConfigurationForm: React.FC<Props> = ({
//   user,
//   config,
//   isEditing,
//   loading = false,
//   onEdit,
//   onCancel,
//   onSubmit,
//   checkPassword,
// }) => {
//   // Obtén la identidad
//   const { identity } = useIdentityStore();

//   // Imagen del usuario
//   const [image, setImage] = useState<string>(user?.image || "");
//   const [oldImage, setOldImage] = useState<string>(user?.image || "");
//   const [fileSelected, setFileSelected] = useState<File | null>(null);

//   // Checkboxes para redes: si la config ya trae info, iniciamos en true
//   const [useTiktok, setUseTiktok] = useState<boolean>(
//     !!(config?.nameTiktok || config?.urlTiktok)
//   );
//   const [useInstagram, setUseInstagram] = useState<boolean>(
//     !!(config?.nameInstagram || config?.urlInstagram)
//   );
//   const [useFacebook, setUseFacebook] = useState<boolean>(
//     !!(config?.nameFacebook || config?.urlFacebook)
//   );
//   const [useX, setUseX] = useState<boolean>(
//     !!(config?.nameTwitter || config?.urlTwitter)
//   );
//   const [useYoutube, setUseYoutube] = useState<boolean>(
//     !!(config?.nameYoutube || config?.urlYoutube)
//   );
//   const [useBluesky, setUseBluesky] = useState<boolean>(
//     !!(config?.bluesky || config?.urlBluesky)
//   );

//   // Validación con Yup (los campos nuevos son opcionales)
//   const validationSchema = Yup.object().shape({
//     // Campos de usuario
//     name: Yup.string().required("Nombre requerido"),
//     lastName: Yup.string().nullable(),
//     email: Yup.string()
//       .required("Username requerido")
//       .email("Formato de email inválido"),

//     // Campos de contacto (opcional)
//     emailContact: Yup.string().email("Formato de email inválido").nullable(),
//     phoneContact: Yup.string().nullable(),

//     // Redes Sociales - Validación condicional
//     nameTiktok: Yup.string().test(
//       "required-if-tiktok",
//       "El Nombre de TikTok es obligatorio si activas la casilla",
//       function (value) {
//         if (useTiktok && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     urlTiktok: Yup.string().test(
//       "required-if-tiktok",
//       "La URL de TikTok es obligatoria si activas la casilla",
//       function (value) {
//         if (useTiktok && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     nameInstagram: Yup.string().test(
//       "required-if-instagram",
//       "El Nombre de Instagram es obligatorio si activas la casilla",
//       function (value) {
//         if (useInstagram && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     urlInstagram: Yup.string().test(
//       "required-if-instagram",
//       "La URL de Instagram es obligatoria si activas la casilla",
//       function (value) {
//         if (useInstagram && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     nameFacebook: Yup.string().test(
//       "required-if-facebook",
//       "El Nombre de Facebook es obligatorio si activas la casilla",
//       function (value) {
//         if (useFacebook && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     urlFacebook: Yup.string().test(
//       "required-if-facebook",
//       "La URL de Facebook es obligatoria si activas la casilla",
//       function (value) {
//         if (useFacebook && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     nameTwitter: Yup.string().test(
//       "required-if-x",
//       "El Nombre de X es obligatorio si activas la casilla",
//       function (value) {
//         if (useX && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     urlTwitter: Yup.string().test(
//       "required-if-x",
//       "La URL de X es obligatoria si activas la casilla",
//       function (value) {
//         if (useX && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     nameYoutube: Yup.string().test(
//       "required-if-youtube",
//       "El Nombre de Youtube es obligatorio si activas la casilla",
//       function (value) {
//         if (useYoutube && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     urlYoutube: Yup.string().test(
//       "required-if-youtube",
//       "La URL de Youtube es obligatoria si activas la casilla",
//       function (value) {
//         if (useYoutube && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     nameBluesky: Yup.string().test(
//       "required-if-bluesky",
//       "El Nombre de Bluesky es obligatorio si activas la casilla",
//       function (value) {
//         if (useBluesky && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),
//     urlBluesky: Yup.string().test(
//       "required-if-bluesky",
//       "La URL de Bluesky es obligatoria si activas la casilla",
//       function (value) {
//         if (useBluesky && !value) {
//           return false;
//         }
//         return true;
//       }
//     ),

//     // Campos nuevos para descripción y cantidad de usuarios (opcionales)
//     descriptionTiktok: Yup.string(),
//     usersTiktok: Yup.string(),
//     descriptionInstagram: Yup.string(),
//     usersInstagram: Yup.string(),
//     descriptionFacebook: Yup.string(),
//     usersFacebook: Yup.string(),
//     descriptionTwitter: Yup.string(),
//     usersTwitter: Yup.string(),
//     descriptionYoutube: Yup.string(),
//     usersYoutube: Yup.string(),
//     descriptionBluesky: Yup.string(),
//     usersBluesky: Yup.string(),
//   });

//   const formik = useFormik({
//     initialValues: {
//       // Campos de User
//       idUser: user?.id || "",
//       name: user?.name || "",
//       lastName: user?.lastName || "",
//       email: user?.email || "",

//       // Campos de Contacto
//       emailContact: config?.emailContact || "",
//       phoneContact: config?.phoneContact || "",

//       // Campos de Config (redes sociales)
//       idConfig: config?.id || "",
//       // TikTok
//       nameTiktok: config?.nameTiktok || "",
//       urlTiktok: config?.urlTiktok || "",
//       descriptionTiktok: config?.descriptionTiktok || "",
//       usersTiktok: config?.usersTiktok || "",
//       // Instagram
//       nameInstagram: config?.nameInstagram || "",
//       urlInstagram: config?.urlInstagram || "",
//       descriptionInstagram: config?.descriptionInstagram || "",
//       usersInstagram: config?.usersInstagram || "",
//       // Facebook
//       nameFacebook: config?.nameFacebook || "",
//       urlFacebook: config?.urlFacebook || "",
//       descriptionFacebook: config?.descriptionFacebook || "",
//       usersFacebook: config?.usersFacebook || "",
//       // X (antes Twitter)
//       nameTwitter: config?.nameTwitter || "",
//       urlTwitter: config?.urlTwitter || "",
//       descriptionTwitter: config?.descriptionTwitter || "",
//       usersTwitter: config?.usersTwitter || "",
//       // Youtube
//       nameYoutube: config?.nameYoutube || "",
//       urlYoutube: config?.urlYoutube || "",
//       descriptionYoutube: config?.descriptionYoutube || "",
//       usersYoutube: config?.usersYoutube || "",
//       // Bluesky
//       nameBluesky: config?.bluesky || "",
//       urlBluesky: config?.urlBluesky || "",
//       descriptionBluesky: config?.descriptionBluesky || "",
//       usersBluesky: config?.usersBluesky || "",
//     },
//     validationSchema,
//     onSubmit: (values) => {
//       // Construimos el user final
//       const finalUser: User = {
//         ...user,
//         name: values.name,
//         lastName: values.lastName,
//         email: values.email,
//         image, // La imagen que tengamos en state
//       };

//       // Construimos la config final
//       const finalConfig: Configuration = {
//         ...config,
//         // Campos de Contacto
//         emailContact: values.emailContact || "",
//         phoneContact: values.phoneContact || "",

//         // TikTok
//         nameTiktok: useTiktok ? values.nameTiktok : "",
//         urlTiktok: useTiktok ? values.urlTiktok : "",
//         descriptionTiktok:
//           identity.role === "ROLE_DEVELOPER" && useTiktok
//             ? values.descriptionTiktok
//             : "",
//         usersTiktok:
//           identity.role === "ROLE_DEVELOPER" && useTiktok
//             ? values.usersTiktok
//             : "",
//         // Instagram
//         nameInstagram: useInstagram ? values.nameInstagram : "",
//         urlInstagram: useInstagram ? values.urlInstagram : "",
//         descriptionInstagram:
//           identity.role === "ROLE_DEVELOPER" && useInstagram
//             ? values.descriptionInstagram
//             : "",
//         usersInstagram:
//           identity.role === "ROLE_DEVELOPER" && useInstagram
//             ? values.usersInstagram
//             : "",
//         // Facebook
//         nameFacebook: useFacebook ? values.nameFacebook : "",
//         urlFacebook: useFacebook ? values.urlFacebook : "",
//         descriptionFacebook:
//           identity.role === "ROLE_DEVELOPER" && useFacebook
//             ? values.descriptionFacebook
//             : "",
//         usersFacebook:
//           identity.role === "ROLE_DEVELOPER" && useFacebook
//             ? values.usersFacebook
//             : "",
//         // X (antes Twitter)
//         nameTwitter: useX ? values.nameTwitter : "",
//         urlTwitter: useX ? values.urlTwitter : "",
//         descriptionTwitter:
//           identity.role === "ROLE_DEVELOPER" && useX
//             ? values.descriptionTwitter
//             : "",
//         usersTwitter:
//           identity.role === "ROLE_DEVELOPER" && useX
//             ? values.usersTwitter
//             : "",
//         // Youtube
//         nameYoutube: useYoutube ? values.nameYoutube : "",
//         urlYoutube: useYoutube ? values.urlYoutube : "",
//         descriptionYoutube:
//           identity.role === "ROLE_DEVELOPER" && useYoutube
//             ? values.descriptionYoutube
//             : "",
//         usersYoutube:
//           identity.role === "ROLE_DEVELOPER" && useYoutube
//             ? values.usersYoutube
//             : "",
//         // Bluesky
//         bluesky: useBluesky ? values.nameBluesky : "",
//         urlBluesky: useBluesky ? values.urlBluesky : "",
//         descriptionBluesky:
//           identity.role === "ROLE_DEVELOPER" && useBluesky
//             ? values.descriptionBluesky
//             : "",
//         usersBluesky:
//           identity.role === "ROLE_DEVELOPER" && useBluesky
//             ? values.usersBluesky
//             : "",
//       };

//       const imageData = {
//         oldImage,
//         image,
//         file: fileSelected || undefined,
//       };

//       onSubmit(finalUser, finalConfig, imageData);
//     },
//     enableReinitialize: true,
//   });

//   // Manejador de la subida de archivos (DragDrop)
//   const handleFiles = (files: any[]) => {
//     if (!files?.length) {
//       setImage("");
//       setFileSelected(null);
//       return;
//     }
//     const file = files[0];
//     if (file.blob) {
//       const blobUrl = URL.createObjectURL(file.blob);
//       setImage(blobUrl);
//       setFileSelected(file.blob as File);
//     }
//   };

//   // Cancelar
//   const handleCancel = () => {
//     formik.resetForm();
//     setImage(oldImage);
//     setFileSelected(null);

//     // Volvemos a marcar o desmarcar checkboxes según config original
//     setUseTiktok(!!(config?.nameTiktok || config?.urlTiktok));
//     setUseInstagram(!!(config?.nameInstagram || config?.urlInstagram));
//     setUseFacebook(!!(config?.nameFacebook || config?.urlFacebook));
//     setUseX(!!(config?.nameTwitter || config?.urlTwitter));
//     setUseYoutube(!!(config?.nameYoutube || config?.urlYoutube));
//     setUseBluesky(!!(config?.bluesky || config?.urlBluesky));

//     onCancel();
//   };

//   return (
//     <form onSubmit={formik.handleSubmit}>
//       <Box mb={3}>
//         <Typography variant="h6" sx={{ mb: 2 }}>
//           Información de Usuario
//         </Typography>

//         {/* Imagen de usuario */}
//         <DragDrop
//           id="user-image"
//           valueDefault={image}
//           disabled={!isEditing || loading}
//           directoryNameList={["user", "images"]}
//           maxSizeMB={2}
//           typeAllowed={["image/*"]}
//           isOnlyOneFile
//           isBlob
//           specialCase
//           showFileList={false}
//           handleFiles={handleFiles}
//         />

//         <Grid container spacing={2} mt={2}>
//           {/* Nombre */}
//           <Grid item xs={12} sm={4}>
//             <TextField
//               variant="standard"
//               label="Nombre"
//               name="name"
//               value={formik.values.name}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               disabled={!isEditing || loading}
//               error={Boolean(formik.touched.name && formik.errors.name)}
//               helperText={
//                 formik.touched.name && formik.errors.name
//                   ? String(formik.errors.name)
//                   : ""
//               }
//               fullWidth
//             />
//           </Grid>

//           {/* Apellidos */}
//           <Grid item xs={12} sm={4}>
//             <TextField
//               variant="standard"
//               label="Apellidos"
//               name="lastName"
//               value={formik.values.lastName}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               disabled={!isEditing || loading}
//               error={Boolean(formik.touched.lastName && formik.errors.lastName)}
//               helperText={
//                 formik.touched.lastName && formik.errors.lastName
//                   ? String(formik.errors.lastName)
//                   : ""
//               }
//               fullWidth
//             />
//           </Grid>

//           {/* Email */}
//           <Grid item xs={12} sm={4}>
//             <TextField
//               variant="standard"
//               label="Username"
//               name="email"
//               value={formik.values.email}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               disabled={!isEditing || loading}
//               error={Boolean(formik.touched.email && formik.errors.email)}
//               helperText={
//                 formik.touched.email && formik.errors.email
//                   ? String(formik.errors.email)
//                   : ""
//               }
//               fullWidth
//             />
//           </Grid>
//         </Grid>

//         {/* Sección de cambio de contraseña */}
//         <Box mt={4}>
//           <Typography variant="h6" sx={{ mb: 2 }}>
//             Contraseña
//           </Typography>
//           <PasswordForm idUser={user?.id} verifyPasswordBackend={checkPassword} />
//         </Box>
//       </Box>

//       {/* Redes Sociales */}
//       <Box mt={4}>
//         <Typography variant="h6" sx={{ mb: 2 }}>
//           Configuración de Redes Sociales
//         </Typography>

//         {/* TIKTOK */}
//         <Box mb={2}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
//                 checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
//                 checked={useTiktok}
//                 onChange={(e) => setUseTiktok(e.target.checked)}
//                 disabled={!isEditing || loading}
//               />
//             }
//             label={
//               <div className="flex items-center gap-2">
//                 <FaTiktok /> <span>TikTok</span>
//               </div>
//             }
//           />

//           {useTiktok && (
//             <>
//               <Grid container spacing={2}>
//                 {/* Nombre TikTok */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="Nombre TikTok"
//                     name="nameTiktok"
//                     value={formik.values.nameTiktok}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.nameTiktok && formik.errors.nameTiktok
//                     )}
//                     helperText={
//                       formik.touched.nameTiktok && formik.errors.nameTiktok
//                         ? String(formik.errors.nameTiktok)
//                         : ""
//                     }
//                     fullWidth
//                   />
//                 </Grid>

//                 {/* URL TikTok */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="URL TikTok"
//                     name="urlTiktok"
//                     value={formik.values.urlTiktok}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.urlTiktok && formik.errors.urlTiktok
//                     )}
//                     helperText={
//                       formik.touched.urlTiktok && formik.errors.urlTiktok
//                         ? String(formik.errors.urlTiktok)
//                         : ""
//                     }
//                     fullWidth
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <FaTiktok />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               {identity.role === "ROLE_DEVELOPER" && (
//                 <Grid container spacing={2} mt={1}>
//                   {/* Descripción TikTok */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Descripción TikTok"
//                       name="descriptionTiktok"
//                       value={formik.values.descriptionTiktok}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       multiline
//                       minRows={3}
//                       inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
//                     />
//                   </Grid>
//                   {/* Cantidad de usuarios TikTok */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Cantidad de usuarios TikTok"
//                       name="usersTiktok"
//                       value={formik.values.usersTiktok}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       InputProps={{
//                         inputComponent: NumericFormatCustom as any,
//                         inputProps: {
//                           noDecimals: true,
//                           noThousandSeparator: true,
//                           maxLength: 10,
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </Box>

//         {/* INSTAGRAM */}
//         <Box mb={2}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
//                 checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
//                 checked={useInstagram}
//                 onChange={(e) => setUseInstagram(e.target.checked)}
//                 disabled={!isEditing || loading}
//               />
//             }
//             label={
//               <div className="flex items-center gap-2">
//                 <FaInstagram /> <span>Instagram</span>
//               </div>
//             }
//           />

//           {useInstagram && (
//             <>
//               <Grid container spacing={2}>
//                 {/* Nombre Instagram */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="Nombre Instagram"
//                     name="nameInstagram"
//                     value={formik.values.nameInstagram}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.nameInstagram && formik.errors.nameInstagram
//                     )}
//                     helperText={
//                       formik.touched.nameInstagram && formik.errors.nameInstagram
//                         ? String(formik.errors.nameInstagram)
//                         : ""
//                     }
//                     fullWidth
//                   />
//                 </Grid>

//                 {/* URL Instagram */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="URL Instagram"
//                     name="urlInstagram"
//                     value={formik.values.urlInstagram}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.urlInstagram && formik.errors.urlInstagram
//                     )}
//                     helperText={
//                       formik.touched.urlInstagram && formik.errors.urlInstagram
//                         ? String(formik.errors.urlInstagram)
//                         : ""
//                     }
//                     fullWidth
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <FaInstagram />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               {identity.role === "ROLE_DEVELOPER" && (
//                 <Grid container spacing={2} mt={1}>
//                   {/* Descripción Instagram */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Descripción Instagram"
//                       name="descriptionInstagram"
//                       value={formik.values.descriptionInstagram}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       multiline
//                       minRows={3}
//                       inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
//                     />
//                   </Grid>
//                   {/* Cantidad de usuarios Instagram */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Cantidad de usuarios Instagram"
//                       name="usersInstagram"
//                       value={formik.values.usersInstagram}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       InputProps={{
//                         inputComponent: NumericFormatCustom as any,
//                         inputProps: {
//                           noDecimals: true,
//                           noThousandSeparator: true,
//                           maxLength: 10,
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </Box>

//         {/* FACEBOOK */}
//         <Box mb={2}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
//                 checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
//                 checked={useFacebook}
//                 onChange={(e) => setUseFacebook(e.target.checked)}
//                 disabled={!isEditing || loading}
//               />
//             }
//             label={
//               <div className="flex items-center gap-2">
//                 <FaFacebookF /> <span>Facebook</span>
//               </div>
//             }
//           />

//           {useFacebook && (
//             <>
//               <Grid container spacing={2}>
//                 {/* Nombre Facebook */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="Nombre Facebook"
//                     name="nameFacebook"
//                     value={formik.values.nameFacebook}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.nameFacebook && formik.errors.nameFacebook
//                     )}
//                     helperText={
//                       formik.touched.nameFacebook && formik.errors.nameFacebook
//                         ? String(formik.errors.nameFacebook)
//                         : ""
//                     }
//                     fullWidth
//                   />
//                 </Grid>

//                 {/* URL Facebook */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="URL Facebook"
//                     name="urlFacebook"
//                     value={formik.values.urlFacebook}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.urlFacebook && formik.errors.urlFacebook
//                     )}
//                     helperText={
//                       formik.touched.urlFacebook && formik.errors.urlFacebook
//                         ? String(formik.errors.urlFacebook)
//                         : ""
//                     }
//                     fullWidth
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <FaFacebookF />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               {identity.role === "ROLE_DEVELOPER" && (
//                 <Grid container spacing={2} mt={1}>
//                   {/* Descripción Facebook */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Descripción Facebook"
//                       name="descriptionFacebook"
//                       value={formik.values.descriptionFacebook}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       multiline
//                       minRows={3}
//                       inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
//                     />
//                   </Grid>
//                   {/* Cantidad de usuarios Facebook */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Cantidad de usuarios Facebook"
//                       name="usersFacebook"
//                       value={formik.values.usersFacebook}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       InputProps={{
//                         inputComponent: NumericFormatCustom as any,
//                         inputProps: {
//                           noDecimals: true,
//                           noThousandSeparator: true,
//                           maxLength: 10,
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </Box>

//         {/* X (antes Twitter) */}
//         <Box mb={2}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
//                 checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
//                 checked={useX}
//                 onChange={(e) => setUseX(e.target.checked)}
//                 disabled={!isEditing || loading}
//               />
//             }
//             label={
//               <div className="flex items-center gap-2">
//                 <FaXTwitter /> <span>X</span>
//               </div>
//             }
//           />
//           {useX && (
//             <>
//               <Grid container spacing={2}>
//                 {/* Nombre X */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="Nombre X"
//                     name="nameTwitter"
//                     value={formik.values.nameTwitter}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.nameTwitter && formik.errors.nameTwitter
//                     )}
//                     helperText={
//                       formik.touched.nameTwitter && formik.errors.nameTwitter
//                         ? String(formik.errors.nameTwitter)
//                         : ""
//                     }
//                     fullWidth
//                   />
//                 </Grid>

//                 {/* URL X */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="URL X"
//                     name="urlTwitter"
//                     value={formik.values.urlTwitter}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.urlTwitter && formik.errors.urlTwitter
//                     )}
//                     helperText={
//                       formik.touched.urlTwitter && formik.errors.urlTwitter
//                         ? String(formik.errors.urlTwitter)
//                         : ""
//                     }
//                     fullWidth
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <FaXTwitter />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               {identity.role === "ROLE_DEVELOPER" && (
//                 <Grid container spacing={2} mt={1}>
//                   {/* Descripción X */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Descripción X"
//                       name="descriptionTwitter"
//                       value={formik.values.descriptionTwitter}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       multiline
//                       minRows={3}
//                       inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
//                     />
//                   </Grid>
//                   {/* Cantidad de usuarios X */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Cantidad de usuarios X"
//                       name="usersTwitter"
//                       value={formik.values.usersTwitter}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       InputProps={{
//                         inputComponent: NumericFormatCustom as any,
//                         inputProps: {
//                           noDecimals: true,
//                           noThousandSeparator: true,
//                           maxLength: 10,
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </Box>

//         {/* YOUTUBE */}
//         <Box mb={2}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
//                 checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
//                 checked={useYoutube}
//                 onChange={(e) => setUseYoutube(e.target.checked)}
//                 disabled={!isEditing || loading}
//               />
//             }
//             label={
//               <div className="flex items-center gap-2">
//                 <FaYoutube /> <span>Youtube</span>
//               </div>
//             }
//           />
//           {useYoutube && (
//             <>
//               <Grid container spacing={2}>
//                 {/* Nombre Youtube */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="Nombre Youtube"
//                     name="nameYoutube"
//                     value={formik.values.nameYoutube}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.nameYoutube && formik.errors.nameYoutube
//                     )}
//                     helperText={
//                       formik.touched.nameYoutube && formik.errors.nameYoutube
//                         ? String(formik.errors.nameYoutube)
//                         : ""
//                     }
//                     fullWidth
//                   />
//                 </Grid>

//                 {/* URL Youtube */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="URL Youtube"
//                     name="urlYoutube"
//                     value={formik.values.urlYoutube}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.urlYoutube && formik.errors.urlYoutube
//                     )}
//                     helperText={
//                       formik.touched.urlYoutube && formik.errors.urlYoutube
//                         ? String(formik.errors.urlYoutube)
//                         : ""
//                     }
//                     fullWidth
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <FaYoutube />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               {identity.role === "ROLE_DEVELOPER" && (
//                 <Grid container spacing={2} mt={1}>
//                   {/* Descripción Youtube */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Descripción Youtube"
//                       name="descriptionYoutube"
//                       value={formik.values.descriptionYoutube}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       multiline
//                       minRows={3}
//                       inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
//                     />
//                   </Grid>
//                   {/* Cantidad de usuarios Youtube */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Cantidad de usuarios Youtube"
//                       name="usersYoutube"
//                       value={formik.values.usersYoutube}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       InputProps={{
//                         inputComponent: NumericFormatCustom as any,
//                         inputProps: {
//                           noDecimals: true,
//                           noThousandSeparator: true,
//                           maxLength: 10,
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </Box>

//         {/* BLUESKY */}
//         <Box mb={2}>
//           <FormControlLabel
//             control={
//               <Checkbox
//                 icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
//                 checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
//                 checked={useBluesky}
//                 onChange={(e) => setUseBluesky(e.target.checked)}
//                 disabled={!isEditing || loading}
//               />
//             }
//             label={
//               <div className="flex items-center gap-2">
//                 <FaBluesky /> <span>Bluesky</span>
//               </div>
//             }
//           />
//           {useBluesky && (
//             <>
//               <Grid container spacing={2}>
//                 {/* Nombre Bluesky */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="Nombre Bluesky"
//                     name="nameBluesky"
//                     value={formik.values.nameBluesky}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.nameBluesky && formik.errors.nameBluesky
//                     )}
//                     helperText={
//                       formik.touched.nameBluesky && formik.errors.nameBluesky
//                         ? String(formik.errors.nameBluesky)
//                         : ""
//                     }
//                     fullWidth
//                   />
//                 </Grid>

//                 {/* URL Bluesky */}
//                 <Grid item xs={12} sm={6}>
//                   <TextField
//                     variant="standard"
//                     label="URL Bluesky"
//                     name="urlBluesky"
//                     value={formik.values.urlBluesky}
//                     onChange={formik.handleChange}
//                     onBlur={formik.handleBlur}
//                     disabled={!isEditing || loading}
//                     error={Boolean(
//                       formik.touched.urlBluesky && formik.errors.urlBluesky
//                     )}
//                     helperText={
//                       formik.touched.urlBluesky && formik.errors.urlBluesky
//                         ? String(formik.errors.urlBluesky)
//                         : ""
//                     }
//                     fullWidth
//                     InputProps={{
//                       startAdornment: (
//                         <InputAdornment position="start">
//                           <FaBluesky />
//                         </InputAdornment>
//                       ),
//                     }}
//                   />
//                 </Grid>
//               </Grid>

//               {identity.role === "ROLE_DEVELOPER" && (
//                 <Grid container spacing={2} mt={1}>
//                   {/* Descripción Bluesky */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Descripción Bluesky"
//                       name="descriptionBluesky"
//                       value={formik.values.descriptionBluesky}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       multiline
//                       minRows={3}
//                       inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
//                     />
//                   </Grid>
//                   {/* Cantidad de usuarios Bluesky */}
//                   <Grid item xs={12} sm={6}>
//                     <TextField
//                       variant="standard"
//                       label="Cantidad de usuarios Bluesky"
//                       name="usersBluesky"
//                       value={formik.values.usersBluesky}
//                       onChange={formik.handleChange}
//                       onBlur={formik.handleBlur}
//                       disabled={!isEditing || loading}
//                       fullWidth
//                       InputProps={{
//                         inputComponent: NumericFormatCustom as any,
//                         inputProps: {
//                           noDecimals: true,
//                           noThousandSeparator: true,
//                           maxLength: 10,
//                         },
//                       }}
//                     />
//                   </Grid>
//                 </Grid>
//               )}
//             </>
//           )}
//         </Box>
//       </Box>

//       {/* Sección de Contacto */}
//       <Box mt={4}>
//         <Typography variant="h6" sx={{ mb: 2 }}>
//           Información de Contacto
//         </Typography>
//         <Grid container spacing={2}>
//           {/* Email de Contacto */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               variant="standard"
//               label="Email de Contacto"
//               name="emailContact"
//               value={formik.values.emailContact}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               disabled={!isEditing || loading}
//               error={Boolean(
//                 formik.touched.emailContact && formik.errors.emailContact
//               )}
//               helperText={
//                 formik.touched.emailContact && formik.errors.emailContact
//                   ? String(formik.errors.emailContact)
//                   : ""
//               }
//               fullWidth
//             />
//           </Grid>

//           {/* Teléfono de Contacto */}
//           <Grid item xs={12} sm={6}>
//             <TextField
//               variant="standard"
//               label="Teléfono de Contacto"
//               name="phoneContact"
//               value={formik.values.phoneContact}
//               onChange={formik.handleChange}
//               onBlur={formik.handleBlur}
//               disabled={!isEditing || loading}
//               error={Boolean(
//                 formik.touched.phoneContact && formik.errors.phoneContact
//               )}
//               helperText={
//                 formik.touched.phoneContact && formik.errors.phoneContact
//                   ? String(formik.errors.phoneContact)
//                   : ""
//               }
//               fullWidth
//             />
//           </Grid>
//         </Grid>
//       </Box>

//       {/* BOTONES DE ACCIÓN */}
//       <Box display="flex" justifyContent="flex-end" gap={2} mt={5}>
//         {!isEditing && (
//           <Button variant="contained" color="primary" onClick={onEdit}>
//             Editar
//           </Button>
//         )}
//         {isEditing && (
//           <>
//             <Button
//               variant="outlined"
//               color="primary"
//               onClick={handleCancel}
//               disabled={loading}
//             >
//               Cancelar
//             </Button>
//             <Button
//               variant="contained"
//               color="primary"
//               type="submit"
//               disabled={loading}
//             >
//               Guardar
//             </Button>
//           </>
//         )}
//       </Box>
//     </form>
//   );
// };

// export default ConfigurationForm;


import React, { useState } from "react";
import {
  Box,
  Grid,
  TextField,
  Button,
  Typography,
  Checkbox,
  FormControlLabel,
  InputAdornment,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";

// Íconos
import { FaFacebookF, FaInstagram, FaTiktok, FaYoutube } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import { FaBluesky } from "react-icons/fa6";

// Modelos
import { User } from "../../../core/models/db";
import { Configuration } from "../../../core/models/db/configuration";

// Componentes
import { NumericFormatCustom, RoundedSquareIcon } from "../../components";
import DragDrop from "../../components/drag-drop/DragDrop";
import PasswordForm from "../user/components/form/PasswordForm";
import { useIdentityStore } from "../../../core/store";

// Variable global para el máximo de caracteres en los campos de descripción
const MAX_DESCRIPTION_LENGTH = 512;

interface Props {
  user: User;
  config: Configuration;
  isEditing: boolean;
  loading?: boolean;
  onEdit: () => void;
  onCancel: () => void;
  checkPassword?: (id: any, password: any) => Promise<any>;
  onSubmit: (
    userData: User,
    configData: Configuration,
    imageData: {
      oldImage: string;
      image: string;
      file?: File;
    }
  ) => void;
}

/**
 * Form para editar User + Configuration,
 * validando que si el usuario marca una red social, se llenen obligatoriamente
 * los campos correspondientes.
 */
const ConfigurationForm: React.FC<Props> = ({
  user,
  config,
  isEditing,
  loading = false,
  onEdit,
  onCancel,
  onSubmit,
  checkPassword,
}) => {
  // Obtén la identidad
  const { identity } = useIdentityStore();

  // Imagen del usuario
  const [image, setImage] = useState<string>(user?.image || "");
  const [oldImage, setOldImage] = useState<string>(user?.image || "");
  const [fileSelected, setFileSelected] = useState<File | null>(null);

  // Checkboxes para redes: si la config ya trae info, iniciamos en true
  const [useTiktok, setUseTiktok] = useState<boolean>(
    !!(config?.nameTiktok || config?.urlTiktok)
  );
  const [useInstagram, setUseInstagram] = useState<boolean>(
    !!(config?.nameInstagram || config?.urlInstagram)
  );
  const [useFacebook, setUseFacebook] = useState<boolean>(
    !!(config?.nameFacebook || config?.urlFacebook)
  );
  const [useX, setUseX] = useState<boolean>(
    !!(config?.nameTwitter || config?.urlTwitter)
  );
  const [useYoutube, setUseYoutube] = useState<boolean>(
    !!(config?.nameYoutube || config?.urlYoutube)
  );
  const [useBluesky, setUseBluesky] = useState<boolean>(
    !!(config?.bluesky || config?.urlBluesky)
  );

  // Validación con Yup (los campos nuevos son opcionales)
  const validationSchema = Yup.object().shape({
    // Campos de usuario
    name: Yup.string().required("Nombre requerido"),
    lastName: Yup.string().nullable(),
    email: Yup.string()
      .required("Username requerido")
      .email("Formato de email inválido"),

    // Campos de contacto (opcional)
    emailContact: Yup.string().email("Formato de email inválido").nullable(),
    phoneContact: Yup.string().nullable(),

    // Redes Sociales - Validación condicional
    nameTiktok: Yup.string().test(
      "required-if-tiktok",
      "El Nombre de TikTok es obligatorio si activas la casilla",
      function (value) {
        if (useTiktok && !value) {
          return false;
        }
        return true;
      }
    ),
    urlTiktok: Yup.string().test(
      "required-if-tiktok",
      "La URL de TikTok es obligatoria si activas la casilla",
      function (value) {
        if (useTiktok && !value) {
          return false;
        }
        return true;
      }
    ),
    nameInstagram: Yup.string().test(
      "required-if-instagram",
      "El Nombre de Instagram es obligatorio si activas la casilla",
      function (value) {
        if (useInstagram && !value) {
          return false;
        }
        return true;
      }
    ),
    urlInstagram: Yup.string().test(
      "required-if-instagram",
      "La URL de Instagram es obligatoria si activas la casilla",
      function (value) {
        if (useInstagram && !value) {
          return false;
        }
        return true;
      }
    ),
    nameFacebook: Yup.string().test(
      "required-if-facebook",
      "El Nombre de Facebook es obligatorio si activas la casilla",
      function (value) {
        if (useFacebook && !value) {
          return false;
        }
        return true;
      }
    ),
    urlFacebook: Yup.string().test(
      "required-if-facebook",
      "La URL de Facebook es obligatoria si activas la casilla",
      function (value) {
        if (useFacebook && !value) {
          return false;
        }
        return true;
      }
    ),
    nameTwitter: Yup.string().test(
      "required-if-x",
      "El Nombre de X es obligatorio si activas la casilla",
      function (value) {
        if (useX && !value) {
          return false;
        }
        return true;
      }
    ),
    urlTwitter: Yup.string().test(
      "required-if-x",
      "La URL de X es obligatoria si activas la casilla",
      function (value) {
        if (useX && !value) {
          return false;
        }
        return true;
      }
    ),
    nameYoutube: Yup.string().test(
      "required-if-youtube",
      "El Nombre de Youtube es obligatorio si activas la casilla",
      function (value) {
        if (useYoutube && !value) {
          return false;
        }
        return true;
      }
    ),
    urlYoutube: Yup.string().test(
      "required-if-youtube",
      "La URL de Youtube es obligatoria si activas la casilla",
      function (value) {
        if (useYoutube && !value) {
          return false;
        }
        return true;
      }
    ),
    nameBluesky: Yup.string().test(
      "required-if-bluesky",
      "El Nombre de Bluesky es obligatorio si activas la casilla",
      function (value) {
        if (useBluesky && !value) {
          return false;
        }
        return true;
      }
    ),
    urlBluesky: Yup.string().test(
      "required-if-bluesky",
      "La URL de Bluesky es obligatoria si activas la casilla",
      function (value) {
        if (useBluesky && !value) {
          return false;
        }
        return true;
      }
    ),

    // Campos nuevos para descripción y cantidad de usuarios (opcionales)
    descriptionTiktok: Yup.string(),
    usersTiktok: Yup.string(),
    descriptionInstagram: Yup.string(),
    usersInstagram: Yup.string(),
    descriptionFacebook: Yup.string(),
    usersFacebook: Yup.string(),
    descriptionTwitter: Yup.string(),
    usersTwitter: Yup.string(),
    descriptionYoutube: Yup.string(),
    usersYoutube: Yup.string(),
    descriptionBluesky: Yup.string(),
    usersBluesky: Yup.string(),
  });

  const formik = useFormik({
    initialValues: {
      // Campos de User
      idUser: user?.id || "",
      name: user?.name || "",
      lastName: user?.lastName || "",
      email: user?.email || "",

      // Campos de Contacto
      emailContact: config?.emailContact || "",
      phoneContact: config?.phoneContact || "",

      // Campos de Config (redes sociales)
      idConfig: config?.id || "",
      // TikTok
      nameTiktok: config?.nameTiktok || "",
      urlTiktok: config?.urlTiktok || "",
      descriptionTiktok: config?.descriptionTiktok || "",
      usersTiktok: config?.usersTiktok || "",
      // Instagram
      nameInstagram: config?.nameInstagram || "",
      urlInstagram: config?.urlInstagram || "",
      descriptionInstagram: config?.descriptionInstagram || "",
      usersInstagram: config?.usersInstagram || "",
      // Facebook
      nameFacebook: config?.nameFacebook || "",
      urlFacebook: config?.urlFacebook || "",
      descriptionFacebook: config?.descriptionFacebook || "",
      usersFacebook: config?.usersFacebook || "",
      // X (antes Twitter)
      nameTwitter: config?.nameTwitter || "",
      urlTwitter: config?.urlTwitter || "",
      descriptionTwitter: config?.descriptionTwitter || "",
      usersTwitter: config?.usersTwitter || "",
      // Youtube
      nameYoutube: config?.nameYoutube || "",
      urlYoutube: config?.urlYoutube || "",
      descriptionYoutube: config?.descriptionYoutube || "",
      usersYoutube: config?.usersYoutube || "",
      // Bluesky
      nameBluesky: config?.bluesky || "",
      urlBluesky: config?.urlBluesky || "",
      descriptionBluesky: config?.descriptionBluesky || "",
      usersBluesky: config?.usersBluesky || "",
    },
    validationSchema,
    onSubmit: (values) => {
      // Construimos el user final
      const finalUser: User = {
        ...user,
        name: values.name,
        lastName: values.lastName,
        email: values.email,
        image, // La imagen que tengamos en state
      };

      // Construimos la config final
      const finalConfig: Configuration = {
        ...config,
        // Campos de Contacto
        emailContact: values.emailContact || "",
        phoneContact: values.phoneContact || "",

        // TikTok
        nameTiktok: useTiktok ? values.nameTiktok : "",
        urlTiktok: useTiktok ? values.urlTiktok : "",
        descriptionTiktok:
          identity.role === "ROLE_DEVELOPER" && useTiktok
            ? values.descriptionTiktok
            : "",
        usersTiktok: useTiktok ? values.usersTiktok : "",

        // Instagram
        nameInstagram: useInstagram ? values.nameInstagram : "",
        urlInstagram: useInstagram ? values.urlInstagram : "",
        descriptionInstagram:
          identity.role === "ROLE_DEVELOPER" && useInstagram
            ? values.descriptionInstagram
            : "",
        usersInstagram: useInstagram ? values.usersInstagram : "",

        // Facebook
        nameFacebook: useFacebook ? values.nameFacebook : "",
        urlFacebook: useFacebook ? values.urlFacebook : "",
        descriptionFacebook:
          identity.role === "ROLE_DEVELOPER" && useFacebook
            ? values.descriptionFacebook
            : "",
        usersFacebook: useFacebook ? values.usersFacebook : "",

        // X (antes Twitter)
        nameTwitter: useX ? values.nameTwitter : "",
        urlTwitter: useX ? values.urlTwitter : "",
        descriptionTwitter:
          identity.role === "ROLE_DEVELOPER" && useX
            ? values.descriptionTwitter
            : "",
        usersTwitter: useX ? values.usersTwitter : "",

        // Youtube
        nameYoutube: useYoutube ? values.nameYoutube : "",
        urlYoutube: useYoutube ? values.urlYoutube : "",
        descriptionYoutube:
          identity.role === "ROLE_DEVELOPER" && useYoutube
            ? values.descriptionYoutube
            : "",
        usersYoutube: useYoutube ? values.usersYoutube : "",

        // Bluesky
        bluesky: useBluesky ? values.nameBluesky : "",
        urlBluesky: useBluesky ? values.urlBluesky : "",
        descriptionBluesky:
          identity.role === "ROLE_DEVELOPER" && useBluesky
            ? values.descriptionBluesky
            : "",
        usersBluesky: useBluesky ? values.usersBluesky : "",
      };

      const imageData = {
        oldImage,
        image,
        file: fileSelected || undefined,
      };

      onSubmit(finalUser, finalConfig, imageData);
    },
    enableReinitialize: true,
  });

  // Manejador de la subida de archivos (DragDrop)
  const handleFiles = (files: any[]) => {
    if (!files?.length) {
      setImage("");
      setFileSelected(null);
      return;
    }
    const file = files[0];
    if (file.blob) {
      const blobUrl = URL.createObjectURL(file.blob);
      setImage(blobUrl);
      setFileSelected(file.blob as File);
    }
  };

  // Cancelar
  const handleCancel = () => {
    formik.resetForm();
    setImage(oldImage);
    setFileSelected(null);

    // Volvemos a marcar o desmarcar checkboxes según config original
    setUseTiktok(!!(config?.nameTiktok || config?.urlTiktok));
    setUseInstagram(!!(config?.nameInstagram || config?.urlInstagram));
    setUseFacebook(!!(config?.nameFacebook || config?.urlFacebook));
    setUseX(!!(config?.nameTwitter || config?.urlTwitter));
    setUseYoutube(!!(config?.nameYoutube || config?.urlYoutube));
    setUseBluesky(!!(config?.bluesky || config?.urlBluesky));

    onCancel();
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <Box mb={3}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Información de Usuario
        </Typography>

        {/* Imagen de usuario */}
        <DragDrop
          id="user-image"
          valueDefault={image}
          disabled={!isEditing || loading}
          directoryNameList={["user", "images"]}
          maxSizeMB={2}
          typeAllowed={["image/*"]}
          isOnlyOneFile
          isBlob
          specialCase
          showFileList={false}
          handleFiles={handleFiles}
        />

        <Grid container spacing={2} mt={2}>
          {/* Nombre */}
          <Grid item xs={12} sm={4}>
            <TextField
              variant="standard"
              label="Nombre"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={!isEditing || loading}
              error={Boolean(formik.touched.name && formik.errors.name)}
              helperText={
                formik.touched.name && formik.errors.name
                  ? String(formik.errors.name)
                  : ""
              }
              fullWidth
            />
          </Grid>

          {/* Apellidos */}
          <Grid item xs={12} sm={4}>
            <TextField
              variant="standard"
              label="Apellidos"
              name="lastName"
              value={formik.values.lastName}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={!isEditing || loading}
              error={Boolean(formik.touched.lastName && formik.errors.lastName)}
              helperText={
                formik.touched.lastName && formik.errors.lastName
                  ? String(formik.errors.lastName)
                  : ""
              }
              fullWidth
            />
          </Grid>

          {/* Email */}
          <Grid item xs={12} sm={4}>
            <TextField
              variant="standard"
              label="Username"
              name="email"
              value={formik.values.email}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={!isEditing || loading}
              error={Boolean(formik.touched.email && formik.errors.email)}
              helperText={
                formik.touched.email && formik.errors.email
                  ? String(formik.errors.email)
                  : ""
              }
              fullWidth
            />
          </Grid>
        </Grid>

        {/* Sección de cambio de contraseña */}
        <Box mt={4}>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Contraseña
          </Typography>
          <PasswordForm idUser={user?.id} verifyPasswordBackend={checkPassword} />
        </Box>
      </Box>

      {/* Redes Sociales */}
      <Box mt={4}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Configuración de Redes Sociales
        </Typography>

        {/* TIKTOK */}
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
                checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
                checked={useTiktok}
                onChange={(e) => setUseTiktok(e.target.checked)}
                disabled={!isEditing || loading}
              />
            }
            label={
              <div className="flex items-center gap-2">
                <FaTiktok /> <span>TikTok</span>
              </div>
            }
          />

          {useTiktok && (
            <>
              <Grid container spacing={2}>
                {/* Nombre TikTok */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="Nombre TikTok"
                    name="nameTiktok"
                    value={formik.values.nameTiktok}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.nameTiktok && formik.errors.nameTiktok
                    )}
                    helperText={
                      formik.touched.nameTiktok && formik.errors.nameTiktok
                        ? String(formik.errors.nameTiktok)
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                {/* URL TikTok */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="URL TikTok"
                    name="urlTiktok"
                    value={formik.values.urlTiktok}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.urlTiktok && formik.errors.urlTiktok
                    )}
                    helperText={
                      formik.touched.urlTiktok && formik.errors.urlTiktok
                        ? String(formik.errors.urlTiktok)
                        : ""
                    }
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaTiktok />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                {identity.role === "ROLE_DEVELOPER" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="standard"
                      label="Descripción TikTok"
                      name="descriptionTiktok"
                      value={formik.values.descriptionTiktok}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={!isEditing || loading}
                      fullWidth
                      multiline
                      minRows={3}
                      inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={identity.role === "ROLE_DEVELOPER" ? 6 : 12}>
                  <TextField
                    variant="standard"
                    label="Cantidad de usuarios TikTok"
                    name="usersTiktok"
                    value={formik.values.usersTiktok}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    fullWidth
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                      inputProps: {
                        noDecimals: true,
                        noThousandSeparator: true,
                        maxLength: 10,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        {/* INSTAGRAM */}
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
                checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
                checked={useInstagram}
                onChange={(e) => setUseInstagram(e.target.checked)}
                disabled={!isEditing || loading}
              />
            }
            label={
              <div className="flex items-center gap-2">
                <FaInstagram /> <span>Instagram</span>
              </div>
            }
          />

          {useInstagram && (
            <>
              <Grid container spacing={2}>
                {/* Nombre Instagram */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="Nombre Instagram"
                    name="nameInstagram"
                    value={formik.values.nameInstagram}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.nameInstagram && formik.errors.nameInstagram
                    )}
                    helperText={
                      formik.touched.nameInstagram && formik.errors.nameInstagram
                        ? String(formik.errors.nameInstagram)
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                {/* URL Instagram */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="URL Instagram"
                    name="urlInstagram"
                    value={formik.values.urlInstagram}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.urlInstagram && formik.errors.urlInstagram
                    )}
                    helperText={
                      formik.touched.urlInstagram && formik.errors.urlInstagram
                        ? String(formik.errors.urlInstagram)
                        : ""
                    }
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaInstagram />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                {identity.role === "ROLE_DEVELOPER" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="standard"
                      label="Descripción Instagram"
                      name="descriptionInstagram"
                      value={formik.values.descriptionInstagram}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={!isEditing || loading}
                      fullWidth
                      multiline
                      minRows={3}
                      inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={identity.role === "ROLE_DEVELOPER" ? 6 : 12}>
                  <TextField
                    variant="standard"
                    label="Cantidad de usuarios Instagram"
                    name="usersInstagram"
                    value={formik.values.usersInstagram}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    fullWidth
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                      inputProps: {
                        noDecimals: true,
                        noThousandSeparator: true,
                        maxLength: 10,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        {/* FACEBOOK */}
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
                checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
                checked={useFacebook}
                onChange={(e) => setUseFacebook(e.target.checked)}
                disabled={!isEditing || loading}
              />
            }
            label={
              <div className="flex items-center gap-2">
                <FaFacebookF /> <span>Facebook</span>
              </div>
            }
          />

          {useFacebook && (
            <>
              <Grid container spacing={2}>
                {/* Nombre Facebook */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="Nombre Facebook"
                    name="nameFacebook"
                    value={formik.values.nameFacebook}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.nameFacebook && formik.errors.nameFacebook
                    )}
                    helperText={
                      formik.touched.nameFacebook && formik.errors.nameFacebook
                        ? String(formik.errors.nameFacebook)
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                {/* URL Facebook */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="URL Facebook"
                    name="urlFacebook"
                    value={formik.values.urlFacebook}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.urlFacebook && formik.errors.urlFacebook
                    )}
                    helperText={
                      formik.touched.urlFacebook && formik.errors.urlFacebook
                        ? String(formik.errors.urlFacebook)
                        : ""
                    }
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaFacebookF />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                {identity.role === "ROLE_DEVELOPER" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="standard"
                      label="Descripción Facebook"
                      name="descriptionFacebook"
                      value={formik.values.descriptionFacebook}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={!isEditing || loading}
                      fullWidth
                      multiline
                      minRows={3}
                      inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={identity.role === "ROLE_DEVELOPER" ? 6 : 12}>
                  <TextField
                    variant="standard"
                    label="Cantidad de usuarios Facebook"
                    name="usersFacebook"
                    value={formik.values.usersFacebook}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    fullWidth
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                      inputProps: {
                        noDecimals: true,
                        noThousandSeparator: true,
                        maxLength: 10,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        {/* X (antes Twitter) */}
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
                checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
                checked={useX}
                onChange={(e) => setUseX(e.target.checked)}
                disabled={!isEditing || loading}
              />
            }
            label={
              <div className="flex items-center gap-2">
                <FaXTwitter /> <span>X</span>
              </div>
            }
          />
          {useX && (
            <>
              <Grid container spacing={2}>
                {/* Nombre X */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="Nombre X"
                    name="nameTwitter"
                    value={formik.values.nameTwitter}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.nameTwitter && formik.errors.nameTwitter
                    )}
                    helperText={
                      formik.touched.nameTwitter && formik.errors.nameTwitter
                        ? String(formik.errors.nameTwitter)
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                {/* URL X */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="URL X"
                    name="urlTwitter"
                    value={formik.values.urlTwitter}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.urlTwitter && formik.errors.urlTwitter
                    )}
                    helperText={
                      formik.touched.urlTwitter && formik.errors.urlTwitter
                        ? String(formik.errors.urlTwitter)
                        : ""
                    }
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaXTwitter />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                {identity.role === "ROLE_DEVELOPER" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="standard"
                      label="Descripción X"
                      name="descriptionTwitter"
                      value={formik.values.descriptionTwitter}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={!isEditing || loading}
                      fullWidth
                      multiline
                      minRows={3}
                      inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={identity.role === "ROLE_DEVELOPER" ? 6 : 12}>
                  <TextField
                    variant="standard"
                    label="Cantidad de usuarios X"
                    name="usersTwitter"
                    value={formik.values.usersTwitter}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    fullWidth
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                      inputProps: {
                        noDecimals: true,
                        noThousandSeparator: true,
                        maxLength: 10,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        {/* YOUTUBE */}
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
                checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
                checked={useYoutube}
                onChange={(e) => setUseYoutube(e.target.checked)}
                disabled={!isEditing || loading}
              />
            }
            label={
              <div className="flex items-center gap-2">
                <FaYoutube /> <span>Youtube</span>
              </div>
            }
          />
          {useYoutube && (
            <>
              <Grid container spacing={2}>
                {/* Nombre Youtube */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="Nombre Youtube"
                    name="nameYoutube"
                    value={formik.values.nameYoutube}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.nameYoutube && formik.errors.nameYoutube
                    )}
                    helperText={
                      formik.touched.nameYoutube && formik.errors.nameYoutube
                        ? String(formik.errors.nameYoutube)
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                {/* URL Youtube */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="URL Youtube"
                    name="urlYoutube"
                    value={formik.values.urlYoutube}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.urlYoutube && formik.errors.urlYoutube
                    )}
                    helperText={
                      formik.touched.urlYoutube && formik.errors.urlYoutube
                        ? String(formik.errors.urlYoutube)
                        : ""
                    }
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaYoutube />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                {identity.role === "ROLE_DEVELOPER" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="standard"
                      label="Descripción Youtube"
                      name="descriptionYoutube"
                      value={formik.values.descriptionYoutube}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={!isEditing || loading}
                      fullWidth
                      multiline
                      minRows={3}
                      inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={identity.role === "ROLE_DEVELOPER" ? 6 : 12}>
                  <TextField
                    variant="standard"
                    label="Cantidad de usuarios Youtube"
                    name="usersYoutube"
                    value={formik.values.usersYoutube}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    fullWidth
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                      inputProps: {
                        noDecimals: true,
                        noThousandSeparator: true,
                        maxLength: 10,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Box>

        {/* BLUESKY */}
        <Box mb={2}>
          <FormControlLabel
            control={
              <Checkbox
                icon={<RoundedSquareIcon checked={false} disabled={!isEditing} />}
                checkedIcon={<RoundedSquareIcon checked={true} disabled={!isEditing} />}
                checked={useBluesky}
                onChange={(e) => setUseBluesky(e.target.checked)}
                disabled={!isEditing || loading}
              />
            }
            label={
              <div className="flex items-center gap-2">
                <FaBluesky /> <span>Bluesky</span>
              </div>
            }
          />
          {useBluesky && (
            <>
              <Grid container spacing={2}>
                {/* Nombre Bluesky */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="Nombre Bluesky"
                    name="nameBluesky"
                    value={formik.values.nameBluesky}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.nameBluesky && formik.errors.nameBluesky
                    )}
                    helperText={
                      formik.touched.nameBluesky && formik.errors.nameBluesky
                        ? String(formik.errors.nameBluesky)
                        : ""
                    }
                    fullWidth
                  />
                </Grid>

                {/* URL Bluesky */}
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="standard"
                    label="URL Bluesky"
                    name="urlBluesky"
                    value={formik.values.urlBluesky}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    error={Boolean(
                      formik.touched.urlBluesky && formik.errors.urlBluesky
                    )}
                    helperText={
                      formik.touched.urlBluesky && formik.errors.urlBluesky
                        ? String(formik.errors.urlBluesky)
                        : ""
                    }
                    fullWidth
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FaBluesky />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>

              <Grid container spacing={2} mt={1}>
                {identity.role === "ROLE_DEVELOPER" && (
                  <Grid item xs={12} sm={6}>
                    <TextField
                      variant="standard"
                      label="Descripción Bluesky"
                      name="descriptionBluesky"
                      value={formik.values.descriptionBluesky}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      disabled={!isEditing || loading}
                      fullWidth
                      multiline
                      minRows={3}
                      inputProps={{ maxLength: MAX_DESCRIPTION_LENGTH }}
                    />
                  </Grid>
                )}
                <Grid item xs={12} sm={identity.role === "ROLE_DEVELOPER" ? 6 : 12}>
                  <TextField
                    variant="standard"
                    label="Cantidad de usuarios Bluesky"
                    name="usersBluesky"
                    value={formik.values.usersBluesky}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    disabled={!isEditing || loading}
                    fullWidth
                    InputProps={{
                      inputComponent: NumericFormatCustom as any,
                      inputProps: {
                        noDecimals: true,
                        noThousandSeparator: true,
                        maxLength: 10,
                      },
                    }}
                  />
                </Grid>
              </Grid>
            </>
          )}
        </Box>
      </Box>

      {/* Sección de Contacto */}
      <Box mt={4}>
        <Typography variant="h6" sx={{ mb: 2 }}>
          Información de Contacto
        </Typography>
        <Grid container spacing={2}>
          {/* Email de Contacto */}
          <Grid item xs={12} sm={6}>
            <TextField
              variant="standard"
              label="Email de Contacto"
              name="emailContact"
              value={formik.values.emailContact}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={!isEditing || loading}
              error={Boolean(
                formik.touched.emailContact && formik.errors.emailContact
              )}
              helperText={
                formik.touched.emailContact && formik.errors.emailContact
                  ? String(formik.errors.emailContact)
                  : ""
              }
              fullWidth
            />
          </Grid>

          {/* Teléfono de Contacto */}
          <Grid item xs={12} sm={6}>
            <TextField
              variant="standard"
              label="Teléfono de Contacto"
              name="phoneContact"
              value={formik.values.phoneContact}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              disabled={!isEditing || loading}
              error={Boolean(
                formik.touched.phoneContact && formik.errors.phoneContact
              )}
              helperText={
                formik.touched.phoneContact && formik.errors.phoneContact
                  ? String(formik.errors.phoneContact)
                  : ""
              }
              fullWidth
            />
          </Grid>
        </Grid>
      </Box>

      {/* BOTONES DE ACCIÓN */}
      <Box display="flex" justifyContent="flex-end" gap={2} mt={5}>
        {!isEditing && (
          <Button variant="contained" color="primary" onClick={onEdit}>
            Editar
          </Button>
        )}
        {isEditing && (
          <>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleCancel}
              disabled={loading}
            >
              Cancelar
            </Button>
            <Button
              variant="contained"
              color="primary"
              type="submit"
              disabled={loading}
            >
              Guardar
            </Button>
          </>
        )}
      </Box>
    </form>
  );
};

export default ConfigurationForm;
